import React, { useState } from 'react';
import SuiteForm from 'src/components/SuiteForm';
import FontAwesomeIcon from 'src/components/Icon';
import Button from 'src/components/Button';
import { MobileDownloadIcon } from 'src/components/SuitesTable/components/mobileDownloadIcon';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';

interface SuiteActionsProps {
  isHomeOwnerCheckUser: boolean;
  suite: any;
  user: any;
  onToggleMobileSync: () => void;
  onReRenderKeyPickupPdf: () => void;
  onFetchDetails: () => void;
  onEditSuite: () => void;
  onDeleteUnit: (suiteId: string) => void;
  showOverlay: boolean;
  onCloseOverlay: () => void;
  onSaveSuite: (
    data: any,
    areas: any,
    floorImage: any
  ) => Promise<{ ok: boolean }>;
}

const SuiteActions = ({
  isHomeOwnerCheckUser,
  suite,
  user,
  onToggleMobileSync,
  onReRenderKeyPickupPdf,
  onFetchDetails,
  onEditSuite,
  onDeleteUnit,
  showOverlay,
  onCloseOverlay,
  onSaveSuite,
}: SuiteActionsProps) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  if (isHomeOwnerCheckUser) {
    return null;
  }

  const userRole: any = user.roles[0]?.role.name;

  const canHandleKeys: boolean = [
    'Property Developer',
    'Admin',
    'Super Admin',
  ].includes(userRole);

  const isKeyHandedOff: any = suite.isKeyHandOff;

  const handleFinalDeleteConfirmation = () => {
    onDeleteUnit(suite.id);
    setIsDeleteModalOpen(false);
  };

  return (
    <>
      {suite.mobileSyncAllowed !== undefined && (
        <MobileDownloadIcon property={suite} onClick={onToggleMobileSync} />
      )}
      {isKeyHandedOff ? (
        <Button
          color="semantic"
          onClick={onReRenderKeyPickupPdf}
          label={<FontAwesomeIcon glyph="redo-alt" weight="solid" />}
        />
      ) : (
        canHandleKeys && (
          <Button
            color="semantic"
            onClick={onFetchDetails}
            label={<FontAwesomeIcon glyph="key" weight="solid" />}
          />
        )
      )}
      <Button
        color="semantic"
        onClick={onEditSuite}
        label={<FontAwesomeIcon glyph="pencil" weight="solid" />}
      />
      <Button
        color="semantic"
        onClick={() => setIsDeleteModalOpen(true)}
        label={
          <FontAwesomeIcon
            glyph="trash"
            weight="solid"
            style={{ color: '#C00' }}
          />
        }
      />
      {isDeleteModalOpen && (
        <ConfirmationModal
          variant="danger"
          title={`Delete Unit ${suite.number}?`}
          confirmLabel="Yes, Delete Everything"
          cancelLabel="Go Back"
          requireTypeToConfirm={true}
          confirmationWord="DELETE"
          message={
            <div>
              <p>You are about to <strong>permanently delete</strong> this unit.</p>
              <p style={{ marginTop: '8px' }}>
                Doing so will immediately destroy all associated data, including:
              </p>
              <ul style={{ textAlign: 'left', display: 'inline-block', marginTop: '8px' }}>
                <li>Completed Key Pickup records</li>
                <li>All Walkthrough history and signatures</li>
                <li>Occupant and Unit history</li>
              </ul>
            </div>
          }
          warningMessage="This action cannot be undone. All data will be lost forever."
          onCancel={() => setIsDeleteModalOpen(false)}
          onConfirm={handleFinalDeleteConfirmation}
        />
      )}
      {showOverlay && (
        <SuiteForm
          key={suite?.id}
          initialSuite={suite}
          onClose={onCloseOverlay}
          onSaveSuite={onSaveSuite}
        />
      )}
    </>
  );
};

export default SuiteActions;